<div class="xea-flex-btn-group-renderer">
  @for (button of buttons; track button) {
    <button
      appThrottleClick
      class="x_full_button x_primary"
      [ngClass]="button.classNames"
      [ngStyle]="buildButtonWidth()"
      (throttledClick)="onBtnClick(button)"
      [disabled]="getButtonDynamicProperty(button, 'disabled') | async"
      [hidden]="getButtonDynamicProperty(button, 'hidden') | async"
    >
      {{ button.caption }}
    </button>
  }
</div>
